/* Semántica canónica de emisores Sabre usados dentro de forms[].remarks[].
   El nombre del arreglo es histórico: no implica que todos sus elementos sean
   remarks de bloque 5. También contiene SSR (3), received (6), ticketing (7),
   phone (9) y comandos directos como PE¥. */

const TYPE_ALIASES = {
  general: 'General',
  invoice: 'Invoice',
  itinerary: 'Itinerary',
  itinerario: 'Itinerary',
  historical: 'Historical',
  historic: 'Historical',
  historico: 'Historical',
  'histórico': 'Historical',
  ticket: 'Ticket',
  phone: 'Phone',
  telefono: 'Phone',
  'teléfono': 'Phone',
  received: 'Received',
  receivedfrom: 'Received',
  'received from': 'Received',
  recibido: 'Received',
  'recibido de': 'Received',
  ticketing: 'Ticketing',
  taw: 'Ticketing',
  ssr: 'SSR',
  osi: 'SSR',
  'ssr/osi': 'SSR',
}

export const REMARK_TYPE_BLOCK = {
  General: 5,
  Invoice: 5,
  Itinerary: 5,
  Historical: 5,
  Ticket: 5,
  Phone: 9,
  Received: 6,
  Ticketing: 7,
  SSR: 3,
}

export function normalizeRemarkType(value) {
  const raw = String(value == null ? '' : value).trim()
  if (!raw) return ''
  return TYPE_ALIASES[raw.toLowerCase()] || ''
}

export function isPeCommandMask(value) {
  const mask = String(value == null ? '' : value).trim()
  return /^PE(?:[¥‡#¤]|$)/i.test(mask)
}

function typeFromMask(value) {
  const mask = String(value == null ? '' : value)
    .trim()
    .replace(/^\[[^\]]+\]/, '')
  if (!mask || isPeCommandMask(mask)) return ''
  if (/^3[A-Z0-9]/i.test(mask) || /^(?:DOCS|DOCO|DOCA|CTCE|CTCM|CTCR|FOID|OSI(?:\s|\/)|SSR(?:\s|\/))/i.test(mask)) return 'SSR'
  if (/^9-?/i.test(mask)) return 'Phone'
  if (/^6/i.test(mask)) return 'Received'
  if (/^7/i.test(mask)) return 'Ticketing'
  if (/^5H-|^H-/i.test(mask)) return 'Historical'
  if (/^5\.|^[.¥‡]/.test(mask)) return 'Itinerary'
  if (/^5-/.test(mask)) return 'Invoice'
  if (/^5\*/.test(mask)) return 'Ticket'
  if (/^5/i.test(mask)) return 'General'
  return ''
}

function typeFromBlock(value) {
  const block = Number(value)
  if (block === 3) return 'SSR'
  if (block === 6) return 'Received'
  if (block === 7) return 'Ticketing'
  if (block === 9) return 'Phone'
  if (block === 5) return 'General'
  return ''
}

export function resolveRemarkSemantics(field = {}) {
  const mask = String(field.remark_mask != null ? field.remark_mask : field.remark || '').trim()
  const currentType = normalizeRemarkType(field.typeremark)
  const maskType = typeFromMask(mask)
  const blockType = typeFromBlock(field.block)

  // PE es un comando directo. Si se le asigna General/block 5, el runtime lo
  // transforma en 5PE¥..., que ya no es la instrucción solicitada.
  if (isPeCommandMask(mask)) {
    return { kind: 'pe', typeremark: '', block: null, source: 'mask' }
  }

  // El prefijo literal del comando es la evidencia más fuerte. Después viene
  // el bloque, y por último el tipo declarado para máscaras aún sin prefijo.
  let typeremark = maskType || (blockType && blockType !== 'General' ? blockType : '') || currentType || blockType
  if (Number(field.block) === 5 && maskType && REMARK_TYPE_BLOCK[maskType] === 5) typeremark = maskType
  if (!typeremark) return { kind: 'unknown', typeremark: '', block: null, source: '' }
  return {
    kind: REMARK_TYPE_BLOCK[typeremark] === 5 ? 'remark' : typeremark.toLowerCase(),
    typeremark,
    block: REMARK_TYPE_BLOCK[typeremark],
    source: maskType ? 'mask' : blockType ? 'block' : 'typeremark',
  }
}

export function normalizeRemarkField(field = {}) {
  const next = { ...field }
  const semantic = resolveRemarkSemantics(next)
  if (semantic.kind === 'pe') {
    delete next.block
    next.typeremark = ''
    return next
  }
  if (semantic.typeremark) {
    next.typeremark = semantic.typeremark
    next.block = semantic.block
  }
  return next
}

export function displayRemarkType(field = {}) {
  return resolveRemarkSemantics(field).typeremark
}
